import React from "react";
import "../css/dashboard.css";
import TopTitleBannerMobile from "../component/TopTitleBannerMobile";
import CollapseComponentMobile from "../component/Misc/CollapseComponentMobile";

export default function DocumentsContentMobile() {

  // useEffect(() => {
  //   if (currentUser?.email) {
  //     recordMetrics(
  //       "Documents",
  //       "pageLoadMobile",
  //       currentUser.email,
  //       "read",
  //       "bodhi"
  //     );
  //   }
  // }, [currentUser.email]);
  return (
    <div className="right-container-mobile">
      <TopTitleBannerMobile title={"Documents"} />
      <CollapseComponentMobile />
    </div>
  );
}
